import { useNavigate, NavigateOptions } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import { getLocalizedPath } from '@/utils/languageUtils';

/**
 * A wrapper around React Router's useNavigate that automatically
 * applies the current language prefix to paths.
 * 
 * This prevents LanguageContext from redirecting (which discards location.state).
 */
export const useLocalizedNavigate = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  return (path: string, options?: NavigateOptions) => {
    const localizedPath = getLocalizedPath(path, language);
    navigate(localizedPath, options);
  };
};
